import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { notifications } from '@mantine/notifications';
import type { UserRole } from '@/types/user.types';

interface ProtectedRouteProps {
  children: ReactNode;
  requireRole?: UserRole;
}

export const ProtectedRoute = ({ children, requireRole }: ProtectedRouteProps) => {
  // Verifica autenticação tanto pela flag quanto pelos dados persistidos
  // Isso permite que a rota seja mantida ao recarregar a página
  const user = useAuthStore((state) => state.user);
  const refreshToken = useAuthStore((state) => state.refreshToken);

  const isAuthenticated = Boolean(user && refreshToken);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Se requireRole foi especificado, verifica se o usuário tem o role necessário
  if (requireRole && user?.role !== requireRole) {
    // Mostra notificação de permissão negada
    notifications.show({
      title: 'Acesso negado',
      message: 'Você não tem permissão para acessar esta página',
      color: 'red',
    });

    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
